import type { ReactNode } from 'react';

/** Bordered panel holding one editable copy field. */
export const CopyCard = ({ children }: { children: ReactNode }) => (
  <div className="rounded-2xl border border-border bg-card p-5">{children}</div>
);

export const CopyCardTitle = ({ children }: { children: ReactNode }) => (
  <p className="mb-2 text-body-md font-semibold text-muted-foreground">{children}</p>
);

export const CopyCardBody = ({ children }: { children: ReactNode }) => (
  <p className="whitespace-pre-wrap text-body-lg">{children}</p>
);

export interface ChannelTabProps {
  label: string;
  selected: boolean;
  onClick: () => void;
}

/**
 * Single-select channel filter. Selection shows only as a text-colour change,
 * which is why the pressed state has to be announced rather than inferred.
 */
export const ChannelTab = ({ label, selected, onClick }: ChannelTabProps) => (
  <button
    type="button"
    aria-pressed={selected}
    onClick={onClick}
    className={`rounded-lg border border-border px-3 py-1.5 text-body-md font-medium ${
      selected ? 'text-foreground' : 'text-muted-foreground'
    }`}
  >
    {label}
  </button>
);
